// The values of the Postgres enums of integration that travel in the contracts (ADR-271): plain tuples, without zod, so
// that @nexxt/db builds its enums without evaluating any schema. The barrel of the domain re-exports them.

/** What a file carries: one record layout, one company, and for the invoices one direction (§7.5). */
export const erpFileKinds = ["items", "sales_invoices", "purchase_invoices"] as const;
export type ErpFileKind = (typeof erpFileKinds)[number];

/**
 * Where a file stands with who imports it: `to_import` until an outcome is recorded; `imported` with every row taken;
 * `rejected` with the rows Business Central refused, the others taken.
 */
export const erpFileStatuses = ["to_import", "imported", "rejected"] as const;
export type ErpFileStatus = (typeof erpFileStatuses)[number];

/**
 * Where a file stands with the shared folder: `pending` until the first attempt, `failed` while the attempts fail
 * (integration tries again, and the file can be downloaded meanwhile), `deposited` once the folder has it.
 */
export const erpFileDepositStatuses = ["pending", "deposited", "failed"] as const;
export type ErpFileDepositStatus = (typeof erpFileDepositStatuses)[number];

export const messageDirections = ["outbound", "inbound"] as const;

export const outboxKinds = ["event", "til"] as const;

export const outboxStatuses = ["pending", "sending", "sent", "acked", "failed", "dead"] as const;

/**
 * How the mock of TIL answers a message Nexxt sends, when a rule of the simulator asks it (ADR-266 §6): `rejected`
 * and `failed` are outcomes of the system behind TIL; `silent` is a message TIL took and nobody ever answers;
 * `unavailable` is TIL out of service (503), `refused` TIL refusing the message itself (422).
 */
export const tilMockAnswers = ["rejected", "failed", "silent", "unavailable", "refused"] as const;
export type TilMockAnswer = (typeof tilMockAnswers)[number];
